import { ButtonConfig } from '../types';

export const BUTTON_CONFIG: ButtonConfig[] = [
  {
    action: 'previous',
    testId: 'find-replace-previous-btn',
    label: 'blox.editorial.toolbar.search_replace.button.previous',
  },
  {
    action: 'next',
    testId: 'find-replace-next-btn',
    label: 'blox.editorial.toolbar.search_replace.button.next',
  },
  {
    action: 'pipe',
  },
  {
    action: 'replace',
    testId: 'find-replace-replace-btn',
    label: 'blox.editorial.toolbar.search_replace.button.replace',
  },
  {
    action: 'replaceAll',
    testId: 'find-replace-replace-all-btn',
    label: 'blox.editorial.toolbar.search_replace.button.replace_all',
  },
];
